module.exports = __webpack_public_path__ + "static/media/audio.57439105.svg";